"use client";
import Step1 from "@/components/ForgotPassword/Step1";
import Step2 from "@/components/ForgotPassword/Step2";
import Step3 from "@/components/ForgotPassword/Step3";
import Image from "next/image";
import Link from "next/link";
import React, { useState, useContext } from "react";
import Input from "@/designs/Input";
import Button from "@/designs/Button";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";

const ForgotPasswordPage = () => {
  const [steps, setSteps] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const { theme } = useContext(CMSModal);
  return (
    <div
      className={twMerge(
        "flex flex-col md:flex-row md:h-screen overflow-y-auto transition-colors",
        theme === "dark" ? "bg-[#191919]" : "bg-gray-50",
      )}
    >
      {/* Left Side: Logo */}
      <div
        className={twMerge(
          "flex justify-center items-center w-full md:h-full transition-colors",
          theme === "dark" ? "bg-[#191919]" : "bg-white",
        )}
      >
        <Image
          src="/Logo.jpeg"
          width={700}
          height={250}
          alt="logo"
          className="object-contain"
          priority
        />
      </div>

      {/* Right Side: Login Form */}
      <div className="flex justify-center items-center bg-[#004175] w-full md:w-1/2 h-full p-6 overflow-y-auto">
        <div
          className={twMerge(
            "w-full max-w-md rounded-2xl shadow-xl p-8 transition-colors border",
            theme === "dark"
              ? "bg-[#262727] border-gray-800"
              : "bg-white border-transparent",
          )}
        >
          <div className="flex flex-col items-center mb-8">
            <h1
              className={twMerge(
                " font-bold mt-4 transition-colors",
                theme === "dark" ? "text-gray-100" : "",
              )}
            >
              Forgot Password
            </h1>
            <p
              className={twMerge(
                "transition-colors",
                theme === "dark" ? "text-gray-400" : "text-gray-600",
              )}
            >
              Enter your email to reset your password
            </p>
          </div>
          {steps == 1 && (
            <Step1
              setSteps={() => setSteps(2)}
              email={email}
              setEmail={setEmail}
            />
          )}
          {steps == 2 && (
            <Step2
              setSteps={() => setSteps(3)}
              otp={otp}
              setOTP={setOtp}
              email={email}
            />
          )}
          {steps === 3 && <Step3 setSteps={() => setSteps(1)} email={email} />}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
